/**
 * Vehicle category feature item type values
 */
export enum VehicleCategoryFeatureItemTypeEnum {
	VEHICLE_CATEGORY_STANDARD = 'vehicle_category_standard',
	VEHICLE_CATEGORY_EXTRA = 'vehicle_category_extra',
}
